<div class="p-6">
  <!-- Page Header -->
  <div class="mb-6">
    <h1 class="text-heading-xl mb-2">{{ 'projects.title' | translate }}</h1>
    <p class="text-body-md text-secondary">{{ 'projects.subtitle' | translate }}</p>
  </div>

  <!-- Projects Table -->
  <p-table 
    #table
    [value]="displayData()" 
    [loading]="false"
    [paginator]="!loading()" 
    [rows]="rows"
    [totalRecords]="totalRecords()"
    [first]="first"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [globalFilterFields]="['name']"
    [stripedRows]="true"
    [tableStyle]="{'table-layout': 'fixed', 'width': '100%'}">
    
    <!-- Table Caption with Search and Add Button -->
    <ng-template pTemplate="caption">
      <div class="flex">
        <div class="flex gap-2">
          @if (loading()) {
            <p-skeleton width="8rem" height="2.5rem"></p-skeleton>
          } @else {
            <p-button 
              label="{{ 'projects.addProject' | translate }}"
              icon="pi pi-plus"
              severity="success"
              [disabled]="loading()"
              (onClick)="addProject()">
            </p-button>
          }
        </div>
        <p-iconfield iconPosition="left" class="ml-auto">
          <p-inputicon>
            <i class="pi pi-search"></i>
          </p-inputicon>
          @if (loading()) {
            <p-skeleton width="12rem" height="2.5rem"></p-skeleton>
          } @else {
            <input 
              pInputText 
              type="text" 
              [disabled]="loading()"
              (input)="table.filterGlobal($any($event.target).value, 'contains')" 
              [placeholder]="'projects.searchPlaceholder' | translate" />
          }
        </p-iconfield>
      </div>
    </ng-template>
    
    <!-- Table Header -->
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="name" class="w-4/5">
          {{ 'projects.headers.name' | translate }}
          <p-sortIcon field="name"></p-sortIcon>
        </th>
        <th class="w-1/5">{{ 'projects.headers.actions' | translate }}</th>
      </tr>
    </ng-template>

    <!-- Table Body -->
    <ng-template pTemplate="body" let-project>
      <tr>
        <td>
          @if (loading()) {
            <p-skeleton width="100%" height="1.25rem"></p-skeleton>
          } @else {
            {{ project.name }}
          }
        </td>
        <td>
          @if (loading()) {
            <div class="flex gap-2">
              <p-skeleton shape="circle" size="2rem"></p-skeleton>
              <p-skeleton shape="circle" size="2rem"></p-skeleton>
            </div>
          } @else {
            <div class="flex gap-2">
              <p-button 
                icon="pi pi-pencil" 
                [rounded]="true"
                size="small"
                [ariaLabel]="'projects.edit' | translate"
                (onClick)="editProject(project)">
              </p-button>
              <p-button 
                icon="pi pi-trash"
                [rounded]="true"
                size="small"
                [ariaLabel]="'projects.delete' | translate"
                (onClick)="deleteProject(project)">
              </p-button>
            </div>
          }
        </td>
      </tr>
    </ng-template>

    <!-- Empty state -->
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="2" class="text-center py-8">
          <div class="flex flex-col items-center gap-3">
            <i class="pi pi-briefcase text-4xl text-muted"></i>
            <p class="text-body-md text-muted">{{ 'projects.noData' | translate }}</p>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- Confirmation Dialog -->
  <p-confirmDialog></p-confirmDialog>
  
  <!-- Toast Messages -->
  <p-toast></p-toast>
</div>